package one.healthium.ui.compose.components.adaptive

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.window.core.layout.WindowSizeClass


@Composable
fun WindowSizeConstraintContainer(
    modifier: Modifier = Modifier,
    contentPadding: (WindowSizeClass) -> PaddingValues = { PaddingValues.Zero },
    content: @Composable () -> Unit
) {

    val windowSizeClass = currentWindowAdaptiveInfo().windowSizeClass

    if (windowSizeClass.isWidthAtLeastBreakpoint(WindowSizeClass.WIDTH_DP_MEDIUM_LOWER_BOUND)) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .then(modifier),
            contentAlignment = Alignment.Center,
        ) {
            Box(
                modifier = Modifier
                    .width(AppAdaptiveDefaults.maxWidthMediumMode)
                    .padding(contentPadding(windowSizeClass))
            ) {
                content()
            }
        }
    } else {
        Box(modifier) {
            content()
        }
    }
}

@Composable
fun WindowSizeConstraintScrollableContainer(
    modifier: Modifier = Modifier,
    additionalContentPadding: PaddingValues = PaddingValues.Zero,
    content: @Composable (PaddingValues) -> Unit
) {
    val windowSizeClass = currentWindowAdaptiveInfo().windowSizeClass

    if (windowSizeClass.isWidthAtLeastBreakpoint(WindowSizeClass.WIDTH_DP_MEDIUM_LOWER_BOUND)) {
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxSize()
                .then(modifier),
        ) {
            val padding = PaddingValues(
                start = ((maxWidth - AppAdaptiveDefaults.maxWidthTwoPaneMode) / 2f).coerceAtLeast(0.dp),
                end = ((maxWidth - AppAdaptiveDefaults.maxWidthTwoPaneMode) / 2f).coerceAtLeast(0.dp),
            )
            content(padding + additionalContentPadding)
        }
    } else {
        Box(modifier) {
            content(additionalContentPadding)
        }
    }
}

@Stable
operator fun PaddingValues.plus(other: PaddingValues): PaddingValues =
    object : PaddingValues {
        override fun calculateLeftPadding(layoutDirection: LayoutDirection): Dp =
            this@plus.calculateLeftPadding(layoutDirection) +
                    other.calculateLeftPadding(layoutDirection)

        override fun calculateTopPadding(): Dp =
            this@plus.calculateTopPadding() + other.calculateTopPadding()

        override fun calculateRightPadding(layoutDirection: LayoutDirection): Dp =
            this@plus.calculateRightPadding(layoutDirection) +
                    other.calculateRightPadding(layoutDirection)

        override fun calculateBottomPadding(): Dp =
            this@plus.calculateBottomPadding() + other.calculateBottomPadding()
    }